import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';
import {FormRowComponent} from './form-row.component';

@NgModule({
    imports: [ RouterModule, CommonModule ],
    declarations: [ FormRowComponent ],
    exports: [ FormRowComponent ]
})

export class FormRowModule {}
